﻿export class HeightCalculator {
	static ComputeHeight(element: HTMLElement): number {
		const childElements = Array.from(element.children);
		const elementStyles = getComputedStyle(element);

		const heightOfChildren = childElements.map(childElement => getComputedStyle(childElement))
			.reduce((height, elementStyles) => {
				return height
					+ parseInt(elementStyles.height)
					+ parseInt(elementStyles.marginBottom)
					+ parseInt(elementStyles.marginTop);
			}, 0);

		return heightOfChildren + parseInt(elementStyles.paddingBottom) + parseInt(elementStyles.paddingTop);
	}
}
